import { useEffect, useId } from "react";

import * as ConsentService from "@/services/consent/consent.service";

import { useReviewsContext } from "../context/reviews.context";
import { ReviewsComponent } from "./reviews.component";

export const Reviews = () => {
    const { range, reviews, sku } = useReviewsContext();

    const id = useId();

    const inViewData: BV.InViewData = {
        productId: sku,
        bvProduct: "RatingsAndReviews"
    };

    // biome-ignore lint/correctness/useExhaustiveDependencies: <TODO>
    useEffect(() => {
        ConsentService.isPerformanceCookiesEnabled().then((enabled) => {
            if (!enabled) return;

            window.BV?.pixel.trackInView(inViewData, { containerId: id });
            window.BV?.pixel.trackViewedCGC(inViewData, {
                containerId: id
            });
        });
    }, []);

    return (
        <ReviewsComponent
            id={id}
            range={range}
            reviews={reviews}
        />
    );
};
